"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../../../session/default-session");
const metadata_provider_1 = require("../metadata-provider");
function Definition(params) {
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const metadataProvider = new metadata_provider_1.MetadataProvider(session);
            return metadataProvider.getGlobal(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy9tZXRhZGF0YS9nbG9iYWwvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx5RUFBaUU7QUFDakUsNERBQXdEO0FBRXhELFNBQWdCLFVBQVUsQ0FBQyxNQUFnRDtJQUN2RSxPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRTtZQUNuQyxNQUFNLGdCQUFnQixHQUFHLElBQUksb0NBQWdCLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFdkQsT0FBTyxnQkFBZ0IsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDOUMsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBUkQsZ0NBUUMifQ==